var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgI1Truck(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 76,
    height: 76,
    viewBox: "0 0 76 76",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M68.67 29H58v14H2v12h4.15a7 7 0 0113.42-2.76A7 7 0 0133 55h23a7 7 0 1114 0h4V45c0-6.62-5.33-16-5.33-16zM62 40v-7h4.86a17 17 0 012 7H62zm5 15a4 4 0 11-8 0 4 4 0 018 0zM55 17H2v23h53V17zm-4 19H6V21h45v15zM30 55a4 4 0 11-8 0 4 4 0 018 0zm-12.86 0a4 4 0 11-8 0 4 4 0 018 0z",
    fill: "currentColor"
  })));
}
export default __webpack_public_path__ + "static/media/I1_Truck.ad0efa91.svg";
export { SvgI1Truck as ReactComponent };